import { render } from "./SettingsModal.vue?vue&type=template&id=84c508b4&scoped=true"
import script from "./SettingsModal.vue?vue&type=script&lang=js"
export * from "./SettingsModal.vue?vue&type=script&lang=js"

import "./SettingsModal.vue?vue&type=style&index=0&id=84c508b4&scoped=true&lang=css"
import "./SettingsModal.vue?vue&type=style&index=1&id=84c508b4&lang=css"

import exportComponent from "/vercel/path0/shinai/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84c508b4"]])

export default __exports__